import React, {useEffect} from 'react';
import Table from 'react-bootstrap/Table';
import PreviewCard from './PreviewCard';
import { useStoreActions, useStoreState } from "easy-peasy";
import { useHistory } from 'react-router-dom';
import { Link, withRouter } from 'react-router-dom';


function PreviewCards () {
  const is_logged_in = useStoreState(state => state.is_logged_in);
  const preview_cards = useStoreState(state => state.preview_cards.preview_cards);
  const domain = useStoreState(state => state.current_domain);
  const account_id = useStoreState(state => state.account_id);
  const get_preview_cards = useStoreActions(actions => actions.preview_cards.getPreviewCards);
  const clear_current_card = useStoreActions(actions => actions.preview_cards.clearCurrentCard);
  const history = useHistory();

  useEffect(() => {
  if (is_logged_in && domain && domain.domain) {
      get_preview_cards(domain.domain);
  }
  clear_current_card();
  }, [domain, get_preview_cards, is_logged_in, history, account_id, clear_current_card]);

  return (
    <div className="container px-0">
      <div className="row">
        <div className="col-12">
          <h3>Link Previews</h3>
          <p>All messages will automatically assume the default link preview (set below) at time of posting.</p>
        </div>
        <div className="col-12">
          <h5><Link to="/preview_card/new" className="text-danger">Create link preview</Link></h5>
        </div>
        <div className="col-12">
          <Table striped bordered responsive>
            <thead>
              <tr>
                <th>Default?</th><th>Image</th><th>Name</th><th>Title</th><th>Description</th><th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
            {preview_cards.map(preview_card => (
              <PreviewCard
                preview_card={preview_card}
                key={preview_card.id}
              />
            ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
}
export default withRouter(PreviewCards);
